/**
 * Licensed Materials - Property of IBM
 * IBM Watson Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import DndSlotItemHandler from './DndSlotItemHandler';

/**
 * Inherits from DndSlotItemHandler and overrides `accepts` method
 */
class DndSlotFilterItemHandler extends DndSlotItemHandler{
	/**
	 * The local filters area can only accept data from
	 * the metadata tree or data grid (type MODEL_ITEM)
	 */
	accepts(dragObject) {
		return (
			(
				((dragObject.type === 'GRID_HEADER_ITEM' || dragObject.type === 'MODEL_ITEM') &&
					dragObject.data && dragObject.data.utils && dragObject.data.utils.isValid()
				)
			) &&
			this.acceptsHandler(dragObject)
		);
	}
}

export default DndSlotFilterItemHandler;



// WEBPACK FOOTER //
// ./src/js/OldSlotEditorComponents/DndSlotFilterItemHandler.js